
import LostLeadsIndex from '../components/lost_leads/LostLeadsIndex.vue';
import Vue from 'vue';

Vue.component('lost-leads-index', LostLeadsIndex);

export default Vue.extend({});
